// eslint-disable-next-line import/prefer-default-export
export const SAFE_DOMAINS = [
  'sentryhealth.ca',
  'localhost',
  'access.sentryhealth.dev',
  'access.qa.sentryhealth.dev',
  'access.sentryhealth.ca',
];
